.a2{flex-direction:row;}